export default __webpack_public_path__ + "static/media/Real-Time Bluedot Wayfinding.9ea3c38a.svg";